import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/prime.css";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import opacity from "react-element-popper/animations/opacity";
import Select from "react-select";

export default function Filter() {
  const tourType = [
    { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
    { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
    { value: "purple", label: "Purple", color: "#5243AA" },
    { value: "red", label: "Red", color: "#FF5630", isFixed: true },
    { value: "orange", label: "Orange", color: "#FF8B00" },
    { value: "yellow", label: "Yellow", color: "#FFC400" },
    { value: "green", label: "Green", color: "#36B37E" },
    { value: "forest", label: "Forest", color: "#00875A" },
    { value: "slate", label: "Slate", color: "#253858" },
    { value: "silver", label: "Silver", color: "#666666" },
  ];
  return (
    <div className="filter-container">
      <div className="title">
        <span className="ps-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 33 30">
            <path id="Icon_feather-filter" data-name="Icon feather-filter" d="M33,4.5H3L15,18.69V28.5l6,3V18.69Z" transform="translate(-1.5 -3)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
          </svg>
        </span>

        <span className="ps-2">فیلتر تور ها</span>
      </div>
      <div>
        <div className="filter-item d-flex flex-wrap m-2 justify-content-center justify-content-lg-start ">
          <Searchbox input={<input type="text" className="form-control" placeholder={"عنوان تور"} />}></Searchbox>
          <Searchbox input={<input type="number" className="form-control" placeholder={"ظرفیت"} />}></Searchbox>
          <Searchbox
            input={
              <DatePicker
              mainPosition="bottom"
               fixMainPosition={true}
              inputClass="w-100 form-control"
               containerClassName="w-100"
                className="w-100"
                calendar={persian}
                id="add-modal-submit-time"
                locale={persian_fa}
                animations={[opacity()]}
                placeholder="تاریخ"
                style={{
                  width: "15%",
                  boxSizing: "border-box",
                  height: "24px",
                  padding: "17.5px 10px",
                  backgroundColor: "white",
                }}
                containerStyle={{
                  width: "15%",
                }}
              />
            }
          ></Searchbox>

          <Searchbox
            input={
              <>
                {" "}
                <input class="form-control" list="datalistOptions" id="exampleDataList" placeholder="نوع تور" />
                <datalist id="datalistOptions">
                  <option value="ایرانگردی" />
                  <option value="خارجی" />
                  <option value="انفرادی" />
                  <option value="کمپینگ" />
                </datalist>
              </>
            }
          ></Searchbox>

          <Searchbox
            input={
              <select className="form-control">
                <option value="" disabled hidden selected>
                  جنسیت
                </option>
                <option value="">مرد</option>
                <option value="">زن</option>{" "}
              </select>
            }
          ></Searchbox>
          <Searchbox input={<input type="number" className="form-control" placeholder={"قیمت"} />}> </Searchbox>
        </div>
      </div>
    </div>
  );
}
export function Searchbox({ input }) {
  return (
    <div className="search-box mt-3">
      <div className="magnifier">
        <svg xmlns="http://www.w3.org/2000/svg" width="15.621" height="15.621" viewBox="0 0 30.621 30.621">
          <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(-3 -3)">
            <path id="Path_211" data-name="Path 211" d="M28.5,16.5a12,12,0,1,1-12-12A12,12,0,0,1,28.5,16.5Z" fill="none" stroke="#8a3ffc" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
            <path id="Path_212" data-name="Path 212" d="M31.5,31.5l-6.525-6.525" fill="none" stroke="#8a3ffc" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
          </g>
        </svg>
      </div>
      {input}
    </div>
  );
}
